// extracted by mini-css-extract-plugin
export default {"component":"ProfileEdit_component__P86U2","dstv_logo":"ProfileEdit_dstv_logo__ZFfHD","title":"ProfileEdit_title__0Go-k","action__container":"ProfileEdit_action__container__Ipryu"};